export default class Stimulus {
    public stimulus: any;

    constructor(stimulus: any) {
        this.stimulus = stimulus;
    }

    get id() {
        return this.stimulus.id;
    }

    get title() {
        return this.stimulus.title;
    }

    set title(value) {
        this.stimulus.title = value;
    }

    get description() {
        return this.stimulus.description;
    }

    set description(value) {
        return (this.stimulus.description = value);
    }

    get type() {
        return this.stimulus.type?.slug ?? this.stimulus.type;
    }

    set type(value) {
        this.stimulus.type = value;
    }

    get data() {
        return this.stimulus.data?.[this.stimulus.type] ?? null;
    }

    set data(value) {
        if (!this.stimulus.data) {
            this.stimulus.data = {};
        }
        this.stimulus.data[this.stimulus.type] = value;
    }

    get files() {
        return this.stimulus.files ?? [];
    }

    is(type: string) {
        return this.stimulus.type === type;
    }
}
